export enum ComponentId {
  REDIRECT = "redirect",
  REGISTRATION_NUMBER = "registrationNumber",
  OC_NUMBER = "ocNumber",
}
